import type { SVGProps } from "react";

export function IconPurpleGrow(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32 46.6667H9.33301V9.33335"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.1665 28.3333V9.33331"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.9925 35.125L53.2145 36.9592C53.4806 37.0268 53.6673 37.2743 53.6638 37.5488C53.4869 51.5408 45.5002 53.6667 45.5002 53.6667C45.5002 53.6667 37.5134 51.5408 37.3365 37.5488C37.333 37.2743 37.5198 37.0268 37.7858 36.9592L45.0079 35.125C45.3309 35.043 45.6694 35.043 45.9925 35.125Z"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.1665 37.3333L29.1665 17.3333"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6665 37.3334L19.6665 27.3334"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
